import type { ColumnSort } from '@tanstack/react-table';

export const DEFAULT_SORT_BY = {
  id: 'name',
  desc: true,
};

const SORT_PARAM = 'sort_by';

export function parseSortByFromUrlParams(
  urlParams: URLSearchParams,
): ColumnSort {
  const sort = urlParams.get(SORT_PARAM);

  return {
    id: sort?.replace('+', '').replace('-', '') ?? DEFAULT_SORT_BY.id,
    desc: sort?.startsWith('-') ?? DEFAULT_SORT_BY.desc,
  };
}

export function formatSortByToUrlParams(
  sortBy?: ColumnSort,
  urlParams?: URLSearchParams,
): URLSearchParams {
  const newUrlParams = new URLSearchParams(urlParams);

  if (sortBy && sortBy.id) {
    const isDefault =
      sortBy.id === DEFAULT_SORT_BY.id && sortBy.desc === DEFAULT_SORT_BY.desc;

    if (isDefault) {
      newUrlParams.delete(SORT_PARAM);
    } else {
      const sortValue = `${sortBy.desc ? '-' : '+'}${sortBy.id}`;

      newUrlParams.set(SORT_PARAM, sortValue);
    }
  }

  return newUrlParams;
}
